export default "__VITE_ASSET__BuwJsCUp__"